import { useCallback, useEffect, useState } from 'react';

import { useScrollEffect } from 'hooks/viewport/useScrollEffect';

export function useTableOfContentsChapterAnchor(
  slugs: string[],
): string | undefined {
  const [chapterAnchor, setChapterAnchor] = useState<string>();

  // TODO: refactor this component so we don't need to update state on every
  // scroll event
  const [scrollY, setScrollY] = useState(0);
  useScrollEffect(
    useCallback(({ scrollY: newScrollY }) => {
      setScrollY(newScrollY);
    }, []),
  );

  useEffect(() => {
    const nodeList = document.querySelectorAll('.anchor-block');
    if (nodeList.length === 0) {
      return;
    }

    const newChapterAnchor = Array.from(nodeList).reduce(
      (acc, node) => (node.getBoundingClientRect().top < 150 ? node : acc),
      nodeList[0],
    ).id;

    if (
      newChapterAnchor !== chapterAnchor &&
      slugs.includes(newChapterAnchor)
    ) {
      setChapterAnchor(newChapterAnchor);
    }
  }, [chapterAnchor, scrollY, slugs]);

  return chapterAnchor;
}
